var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "input_delivery" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main_content wrapper" },
        [
          _c("dd-menu", { ref: "menuRef" }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("dd-flow", {
                attrs: {
                  pageKey: _vm.pageKey,
                  pageList: _vm.orderForm.pageList
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input_list" }, [
                _c("div", [
                  _c("ul", [
                    _c("li", { staticClass: "input_text2" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.userLastName,
                              expression: "form.userLastName"
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "家具"
                          },
                          domProps: { value: _vm.form.userLastName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userLastName",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "space" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.userFirstName,
                              expression: "form.userFirstName"
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "太郎"
                          },
                          domProps: { value: _vm.form.userFirstName },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userFirstName",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.userName
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.userName))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text2" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "input_field" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.userLastNameKana,
                              expression: "form.userLastNameKana"
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "カグ"
                          },
                          domProps: { value: _vm.form.userLastNameKana },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userLastNameKana",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "space" }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.userFirstNameKana,
                              expression: "form.userFirstNameKana"
                            }
                          ],
                          attrs: {
                            type: "text",
                            maxlength: "32",
                            placeholder: "タロウ"
                          },
                          domProps: { value: _vm.form.userFirstNameKana },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.form,
                                "userFirstNameKana",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.errors.userNameKana
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.userNameKana))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tel,
                            expression: "form.tel"
                          }
                        ],
                        attrs: {
                          type: "text",
                          oninput: "if(value.length>16)value=value.slice(0,16)",
                          placeholder: "0123456789"
                        },
                        domProps: { value: _vm.form.tel },
                        on: {
                          keypress: _vm.validateNumber,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.form, "tel", $event.target.value)
                            },
                            function($event) {
                              _vm.form.tel = _vm.inputRestNumber($event)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.tel
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.tel))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "input_text" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.email,
                            expression: "form.email"
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "****@domans.co.jp",
                          maxlength: "128"
                        },
                        domProps: { value: _vm.form.email },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "email", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.errors.email
                        ? _c("div", { staticClass: "error_text" }, [
                            _vm._v(_vm._s(_vm.errors.email))
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.errors.deliveryDate
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(_vm._s(_vm.errors.deliveryDate))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input_error_field" }, [
                Object.keys(_vm.errors).length > 0
                  ? _c("div", { staticClass: "error_text" }, [
                      _vm._v(
                        "入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。"
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "control_btn_area" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn2",
                      on: {
                        click: function($event) {
                          _vm.onPrev()
                        }
                      }
                    },
                    [_vm._v("〈〈   戻る   ")]
                  ),
                  _vm._v(" "),
                  _vm.orderForm.workFlag
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "detail_btn",
                            on: {
                              click: function($event) {
                                _vm.confirm()
                              }
                            }
                          },
                          [_vm._v("組立設置先入力 〉〉")]
                        )
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticClass: "detail_btn",
                            on: {
                              click: function($event) {
                                _vm.confirm()
                              }
                            }
                          },
                          [_vm._v("ご注文内容確認 〉〉")]
                        )
                      ]
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("発注者情報入力")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("発注者名")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("発注者名（カナ）")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("発注者電話番号")]),
      _vm._v(" "),
      _c("span", { staticClass: "small_p" }, [
        _vm._v("（半角数値、ハイフン不要）")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("メールアドレス")]),
      _vm._v(" "),
      _c("span", { staticClass: "important small_text" }, [_vm._v("必須")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b778830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b778830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcOrderGuest.vue
// module id = null
// module chunks = 